// DialogTaskDetail Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Select from '../../../common/form/select/select.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class DialogTaskDetail extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      projectId: null,
      activityId: null
    }

    this.data = {
      task: null,
      nonTrackedMinutes: 0,
      projects: [],
      activities: []
    }

    this._references = {
      selectProject: React.createRef(),
      selectActivity: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onSearchActivity: PropTypes.func,
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onSearchActivity: null,
      onClose: null
    }
  }

  show (task, nonTrackedMinutes, projects) {
    this.data.task = _.cloneDeep(task)
    this.data.nonTrackedMinutes = nonTrackedMinutes
    this.data.projects = projects || []

    this.setState({
      active: true,
      projectId: task.projectId,
      activityId: task.activityId
    })
  }

  hide (_bShow) {
    this.setState({
      active: false,
      projectId: null,
      activityId: null
    })
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const { activity, projectId, activityId } = this.state

    return (
      <Dialog
        active={this.state.active}
        onClose={this._onClose.bind(this)}
        className='dialog-taskadd'
      >
        <div className='dialog-form dialog-timecardDetailform'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='task.form.taskEditTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='task.form.addErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          options={this.data.projects}
                          name='project'
                          label='task.form.projectLabel'
                          ref={this._references.selectProject}
                          className='form-dropdown'
                          disabled={!!activity}
                          onChange={this._onChangeProject.bind(this)}
                          value={projectId}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          options={this.data.activities}
                          name='activity'
                          label='task.form.activityLabel'
                          ref={this._references.selectActivity}
                          className='form-dropdown'
                          disabled={!!activity}
                          onChange={this._onChangeBudgetItem.bind(this)}
                          value={activityId}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='task.form.tipSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this, false)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (bOpen, ev) {
    ev.preventDefault()

    let noError = 0
    if (
      this._references.selectActivity.current &&
      !this._references.selectActivity.current.validate()
    ) {
      noError++
    }

    if (
      this._references.selectProject.current &&
      !this._references.selectProject.current.validate()
    ) {
      noError++
    }

    if (noError === 0) {
      const taskObj = this.data.task
      taskObj.projectId = this.state.projectId
      taskObj.activityId = this.state.activityId

      const activity = _.find(
        this.data.activities,
        (obj) => obj.value === this.state.activityId
      )
      taskObj.active = activity ? activity.isActive : false

      if (this.props.onSubmit) {
        this.props.onSubmit(taskObj, this.data.nonTrackedMinutes)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClose () {
    this.hide()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _onChangeProject (projectId) {
    this._getActivitiesOfProject(projectId, (activities) => {
      this.data.activities = activities
      this.setState({ projectId: projectId, dataDate: new Date() })
    })
  }

  _getActivitiesOfProject (projectId, callback) {
    this.props.onSearchActivity(projectId, (activities) => {
      callback(activities)
    })
  }

  _onChangeBudgetItem (activityId) {
    this.setState({ activityId: activityId })
  }
}

export default DialogTaskDetail
